module.exports = __webpack_public_path__ + "img/sun-behind-small-cloud.828e4339.png";